import script from "./TeamNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamNavigation.vue?vue&type=script&setup=true&lang=js"

import "./TeamNavigation.vue?vue&type=style&index=0&id=45f1faf7&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45f1faf7"]])

export default __exports__